import { render } from "./MaintenancePage.vue?vue&type=template&id=53f5d90e&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&lang=js"

import "./MaintenancePage.vue?vue&type=style&index=0&id=53f5d90e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\randy\\Documents\\Développement\\my-portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f5d90e"]])

export default __exports__